export var OAuthClientType;
(function (OAuthClientType) {
    OAuthClientType["CONFIDENTIAL"] = "confidential";
    OAuthClientType["PUBLIC"] = "public";
})(OAuthClientType || (OAuthClientType = {}));
export var OAuthConsentStatus;
(function (OAuthConsentStatus) {
    OAuthConsentStatus["ACTIVE"] = "active";
    OAuthConsentStatus["REVOKED"] = "revoked";
})(OAuthConsentStatus || (OAuthConsentStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL29hdXRoL21vZGVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBTixJQUFZLGVBR1g7QUFIRCxXQUFZLGVBQWU7SUFDekIsZ0RBQTZCLENBQUE7SUFDN0Isb0NBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUhXLGVBQWUsS0FBZixlQUFlLFFBRzFCO0FBRUQsTUFBTSxDQUFOLElBQVksa0JBR1g7QUFIRCxXQUFZLGtCQUFrQjtJQUM1Qix1Q0FBaUIsQ0FBQTtJQUNqQix5Q0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSFcsa0JBQWtCLEtBQWxCLGtCQUFrQixRQUc3QiJ9